export default __webpack_public_path__ + "static/media/three.d321a048.jpg";